import React from "react";
import Loader from 'react-loader-spinner'
import { getBoundingClientRect } from "../../utils/functions";
import HttpService from '../../utils/Http.services';
import { checkTextTranslation, translate } from "../../utils/useful";


class MultiSelectFilterInput extends React.Component {
    constructor(props) {
        super(props);
        this.endOfListRef = React.createRef();
        this.openedRect = React.createRef();
        this.debouncedSearch = this.debounce(this.fetch, 700);
    }
    state = {
        isOpen: false,
        data: [],
        title: '',
        tempData: [],
        options: [],
        isLoading: false,
        choosen: [],
        lastNewId: 0,
        operator: 'in',
        limit: 20,
        page: 0,
        searchPage: 0,
        isSearching:false

    }
    debounce(func, wait) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }
    toggleOpen = (open) => {
        // console.log("HERE")
        let openState = open != null ? open : !this.state.isOpen
        if (!this.state.isOpen && !this.state.maxPage && !this.state.isSearching &&  this.props.header.information.type === "api") {

            this.fetch()
        }
        if (openState) {
            document.addEventListener('mousedown', this.closeBox);
            window.addEventListener('scroll', this.getPosition, true);
            this.getPosition()

        } else {
            document.removeEventListener('mousedown', this.closeBox);
            window.removeEventListener('scroll', this.getPosition);

        }
        // this.refs.icon.classList.toggle("rotate-180")

        this.setState({ isOpen: openState, data: this.props.data })

    }

    // openBox = () => {

    //     if (!this.state.isOpen) {
    //         document.addEventListener('mousedown', this.closeBox);
    //     }
    //     // this.refs.icon.classList.toggle("rotate-180")

    //     this.setState({ isOpen: true, data: this.props.data })

    // }

    closeBox = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
            this.setState({ isOpen: false, data: this.props.data })
            document.removeEventListener('mousedown', this.closeBox);
            window.removeEventListener('scroll', this.getPosition);

            // this.refs.icon.classList.toggle("rotate-180")

        }
    }


    getPosition = () => {
        let rect = getBoundingClientRect(this.wrapperRef)
        this.setState({ top: rect.top + 35, left: rect.left - 10 })
        if (this.endOfListRef.current) {
            const openedRect = getBoundingClientRect(this.openedRect.current);
            this.setState({ openedRect })
            const { top } = this.endOfListRef.current.getBoundingClientRect();

            // console.log('filllllllllterrrrrrrrrrrrrrrr',openedRect.bottom,top);
            if (top - 0.001 <= (openedRect.bottom)) {
if(this.state.isSearching){
    if(this.state.searchPage < this.state.maxSearchPage &&  this.props.header.information.type === "api" ){

        this.fetch();
    }
}else{
    if (this.state.page < this.state.maxPage && this.props.header.information.type === "api" ) {

        this.fetch();
    }

}
            }
        }
    }

    changeItem = (prop, selected, dontChangeValue) => {

        // console.log("CHANGE")
        var choosen = this.state.choosen
        this.setState({ title: '' }, () => {
            if (this.refs.input)
                this.refs.input.focus()
        })


        if (selected) {
            for (let i = 0; i < choosen.length; i++) {

                if (choosen[i].value == prop.value) {
                    choosen.splice(i, 1)
                }
            }
        } else {
            choosen.push(prop)
        }

        this.setState({ choosen }, () => {
            if (!dontChangeValue) this.changeValue()
        })

        setTimeout(() => {
            this.toggleOpen(true)
        }, 1);

        // setTimeout(
        //     function () {
        //         this.toggleOpen()
        //     }
        //         .bind(this),
        //     1
        // );


        if (this.state.tempData.length > 0)
            this.setState({ options: this.state.tempData })

        // this.changeFilter(prop.value)

    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    componentDidMount() {
        this.mounted = true
        // console.log(this.props.data)
        this.init()

    }

    componentDidUpdate(prevProps) {
        // console.log(this.props.data)

        if (prevProps.data != this.props.data && this.mounted) {
            // this.init()
        }
    }

    componentWillUnmount() {
        this.mounted = false
    }


    init() {
        if (this.props.header.information) {
            if (this.props.header.information.type == "local") {

                let options = []
                let choosen = []

                if (this.props.header.information.items && this.props.header.information.items.length > 0) {
                    options = this.props.header.information.items
                }
                if (this.props.data) {
                    let data = Array.isArray(this.props.data) ? this.props.data : [this.props.data]
                    options.forEach(o => {
                        data.forEach(d => {
                            if (o.value == d) {
                                choosen.push(o)
                            }
                        });
                    });

                }
                // console.log(this.props.title)
                this.setState({ options, choosen })
            } else if (this.props.header.information.type == "api") {
                // console.log(this.props.title)
                this.fetch(true)
            }
        }
    }


    fetch(init, text, isSearching) {
        if (init && !(Array.isArray(this.props.data) && this.props.data.length > 0) && !(isSearching || this.state.isSearching)) {
            return
        }
        // if (!isSearching && this.state.text) {
        //     return
        // }
        if (isSearching && !text) {
            this.setState({
                options: this.state.tempData,
                searchPage:0,
                maxSearchPage:null,
                isSearching:false

            }, () => {

            })
        } else {

            if (!init) {
                this.setState({ isLoadingInside: true })
            } else {
                this.setState({ isLoading: true })
            }
            window.removeEventListener('scroll', this.getPosition, true);
            let address = this.props.header.information.address
            let filter = typeof this.props.header.information.filter == "string" ? JSON.parse(this.props.header.information.filter) : JSON.parse(JSON.stringify(this.props.header.information.filter))
            // console.log('ffffff',filter);
            // return
            if (this.props.header.information.sort) {
                filter.sort = this.props.header.information.sort
            }
            for (const [key, value] of Object.entries(filter)) {
                if (/\{\{(.*?)\}\}/.test(value)) {
                    if (this.props.variables) {
                        filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
            }
            if (text ) {
                filter.skip = 0
                filter.getCount = true
                
                filter.limit = this.state.limit
                if (!filter.filter2) {
                    filter.filter2 = {}
                }

                filter.filter2[this.props.header.information.fields.title] = {
                    key: this.props.header.information.fields.title,
                    value: text,
                    operator: 'contains',
                    type: 'SelectInput',
                    label: this.props.header.information.fields.title
                }

            } else if(this.state.isSearching  && this.state.maxSearchPage) {
                filter.skip = this.state.searchPage
                filter.limit = this.state.limit
                if (!filter.filter2) {
                    filter.filter2 = {}
                }

                filter.filter2[this.props.header.information.fields.title] = {
                    key: this.props.header.information.fields.title,
                    value: this.state.text,
                    operator: 'contains',
                    type: 'SelectInput',
                    label: this.props.header.information.fields.title
                }
            }
            if (filter.filter) {
                for (const [key, value] of Object.entries(filter.filter)) {
                    if (/\{\{(.*?)\}\}/.test(value)) {

                        if (this.props.variables) {
                            filter.filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                        }
                        // console.log('f=========2', value.replace(/{/g, '').replace(/}/g, ''))
                        // console.log("VAR")
                    }
                }
            }
            if (Array.isArray(this.props.data) && init && !isSearching) {
                if (!filter.filter2) {
                    filter.filter2 = {}
                }
                filter.filter2[this.props.header?.information?.fields?.value] = {
                    key: this.props.header?.information?.fields?.value,
                    value: this.props.data,
                    operator: 'in',
                    type: 'MultiSelectInput',
                    label: this.props.header?.information?.fields?.value
                }
            }
            // console.log('f=========',filter)
            // console.log('f=========3', this.props.variables)

            if (!init && !this.state.maxSearchPage ) {

                filter.limit = this.state.limit
                filter.skip = this.state.page
                if (!this.state.maxPage) {
                    filter.getCount = true
                }
            }
            // else if(!init && this.state.maxSearchPage){
            //     filter.limit = this.state.limit
            //     filter.skip = this.state.searchPage

            // }
             if(!filter.country && !filter.filter?.country && !filter.filter2?.country){
                filter.NoCountry = true
            }
            console.log('filllllllllterrrrrrrrrrrrrrrr',address, filter)
            HttpService.request(address, filter, (fetchResult, fetchError) => {
                // console.log(fetchError)
                if (fetchError
                    //  ||( fetchResult && Array.isArray(fetchResult.info)&& fetchResult.info.length == 0)
                ) {
                    this.setState({ isLoading: false, isLoadingInside: false })
                    return
                }
                var prevData = JSON.parse(JSON.stringify(this.state.options))
                var newData = (this.state.options.length > 1) ? this.state.options : []
                if (isSearching) (
                    newData = []
                )
                if (!this.state.maxPage && !init) {
                    if (fetchResult.count) {
                        this.setState({ maxPage: Math.ceil(fetchResult.count / this.state.limit) }, () => {
                            // console.log('filllllllllterrrrrrrrrrrrrrrr', this.state.maxPage)

                        })
                    }
                }
                if(text){
                    
                    this.setState({maxSearchPage : Math.ceil(fetchResult.count / this.state.limit)})
                }else{

                    
                    if (!init) {
                        this.setState({ page: this.state.page + 1 })
                        
                    } else {
                        this.setState({ page: 0 })
                        
                    }
                }
                if(this.state.maxSearchPage || text){
                    this.setState({searchPage:this.state.searchPage + 1})
                }
               
                fetchResult.info.forEach(element => {

                    var newTitle = this.spliter(element, this.props.header.information.fields.title)
                    var newValue = this.spliter(element, this.props.header.information.fields.value)
                    let newDescription
                    if (this.props.header.information.fields.description) {
                        newDescription = this.spliter(element, this.props.header.information.fields.description)
                    }
                    newData.push({ value: newValue, title: newTitle, description: newDescription })
                    prevData.push({ value: newValue, title: newTitle, description: newDescription })
                    // var newTitle = this.spliter(element, this.props.header.information.fields.title)
                    // var newValue = this.spliter(element, this.props.header.information.fields.value)

                    // newData.push({ value: newValue, title: newTitle })
                });

                console.log(this.props.data)

                if (Array.isArray(this.props.data) && this.state.choosen.length == 0) {
                    let choosen = []
                    this.props.data.forEach(oneTitle => {
                        let oneTitleId = typeof oneTitle == 'object' ? oneTitle._id : oneTitle
                        newData.forEach(oneNewData => {

                            if (oneNewData.value == oneTitleId) {
                                choosen.push({ title: oneNewData.title, value: oneTitleId })
                            }
                        });

                    })

                    console.log(choosen)

                    this.setState({ choosen })


                }
                let tempData = this.state.tempData
                if (!(isSearching || this.state.isSearching)) {
                    tempData = newData
                }


                this.setState({
                    options: newData,

                    tempData: tempData,
                    prevData: prevData,
                    isLoading: false,
                    isLoadingInside: false
                }, () => {
                    setTimeout(() => {
                        window.addEventListener('scroll', this.getPosition, true)
                    }, 500);
                })
            })

            // }).catch(error => this.setState({ error, isLoading: false }));
        }
    }


    spliter(source, string) {
        var stringArray = string.split('.')
        var finalString = source
        stringArray.forEach(element => {
            finalString = finalString[element]
        });
        return finalString
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }


    search = async (init, value, isSearching) => {
        this.setState({text:value,isSearching:true},async()=>{

            if (this.props.header.information.type === "api") {
                this.debouncedSearch(init, value, isSearching)
            } else {
                // console.log(value)
                this.setState({ title: value })
                if (!this.state.isOpen) {
                    this.toggleOpen()
                }

                if (value == "") {
                    await this.setState({ options: this.state.tempData })
                    await this.setState({ tempData: [] })
                } else {
                    if (this.state.tempData.length == 0) {
                        await this.setState({ tempData: this.state.options })
                    }
                    var values = []
                    // var values = this.props.data.filter((e) => e.title === value)
                    // console.log(this.state.tempData)
                    this.state.tempData.forEach(element => {
                        if (String(element.title).toLowerCase().includes(String(value).toLowerCase())|| String(element.description).toLowerCase().includes(String(value).toLowerCase())) {
                            values.push(element)
                        }
                    })
                    // console.log(values)

                    this.setState({ options: values })

                    // }
                }
            }
        })

    }

    removeItem(index) {
        let choosen = [...this.state.choosen]
        choosen.splice(index, 1)
        this.setState({ choosen }, () => {
            this.changeValue()
        })
    }


    addTag() {
        let tempData = [...this.state.tempData]
        let choosen = [...this.state.choosen]

        let item = { title: this.state.title, value: this.state.title }
        tempData.push(item)
        // choosen.push(item)
        this.setState({ tempData }, () => {
            this.changeItem(item, false)
        })
        this.refs.input.focus()
    }

    changeValue() {
        let choosen = []
        let dictionary = {}
        this.state.choosen.forEach(element => {
            let id = (typeof element.value == 'object' ? element.value._id : element.value)
            choosen.push(id)
            dictionary[id] = element.title
            // choosen.push((element.value))
        });
        // console.log(dictionary)

        this.props.changeValue(this.props.header.key, choosen, { type: this.props.header.type, operator: this.state.operator, label: this.props.header.information?.label, dictionary })
    }


    render() {

        return (
            <div ref={ref => this.setWrapperRef(ref)} className='mt-0 w-100 h-100 flexc' style={{ position: 'relative' }} onClick={() => this.toggleOpen(true)} >
                <span style={{ opacity: 0 }}>0</span>

                {this.props.header.information.placeholder && !this.state.choosen?.length && (
                    <div className="h-100 flexc" style={{ position: 'absolute', top: 0 }}>
                        <label className={' mr-1 ml-1 placeholder '}>{checkTextTranslation(this.props.header.information.placeholder)}</label>
                    </div>
                )}

                <div className="wrapper w-100"  >
                    <div style={{ flexWrap: 'wrap', borderRadius: 4, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                        {this.state.choosen.map((prop, index) => {
                            return (
                                <div key={index} className="" style={{ display: 'inline-flex', alignItems: 'center', paddingTop: 2, paddingBottom: 2 }}>
                                    <div className="flexcc" key={index} style={{ padding: 5, backgroundColor: '#78b2d020', borderRadius: 4, marginRight: 2, marginLeft: 2, flexWrap: 'nowrap', paddingLeft: 7, paddingRight: 7 }}>
                                        <p style={{ whiteSpace: 'nowrap', marginBottom: 0, marginRight: 2, marginLeft: 2, fontSize: 12, marginTop: 0, color: '#202020' }}>{prop.title}</p>
                                        <img src="/images/close1.svg" onClick={() => this.removeItem(index)} style={{ padding: 2, paddingLeft: 0, color: '#78b2d0', width: 14, height: 14 }} />
                                    </div>
                                    {/* {index != this.state.choosen.length - 1 && (
                                        <i className="fa fa-arrow-right" style={{ color: '#78b2d0' }}></i>

                                    )} */}
                                </div>
                            )
                        })}
                        {/* <div className={"position-relative mt-0 ml-1 "}> */}
                        {/* {!this.state.isFinal && (
                                <input ref={'input'} value={this.state.title} onFocus={() => { this.toggleOpen() }} onInput={event => this.search(event.target.value)} onChange={e => { this.props.changeValue(this.props.headerkey, e.target.value) }} className='nofocus mediumiransansfont' style={{ backgroundColor: 'transparent', minWidth: 100, width: this.state.title.length * 9, border: 'none' }} />
                            )} */}
                        {this.state.isLoading && (
                            <div style={{ position: 'absolute', top: 0, right: 5 }}>
                                <Loader
                                    type="Oval"
                                    color="rgba(0,122,255,1)"
                                    height="20"
                                    width="20"
                                />
                            </div>
                        )}
                        {/* </div> */}
                        {this.state.isFinal && (<i className="fa fa-check-circle ml-1" style={{ color: '#78b2d0', fontSize: 20 }}></i>)}

                    </div>

                    {this.state.isOpen && (
                        <div style={{ display: 'flex', position: 'fixed', top: this.state.top, left: this.state.left, width: '100%', maxWidth: 300, zIndex: 40 }}>
                            <div ref={this.openedRect} className={'search-drop-down blur-back'} style={{ display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: '#ffffffdd', borderColor: '#eee', borderRadius: 4, maxHeight: 250, overflow: 'auto', boxShadow: '0px 0px 10px rgba(0,0,0,0.1)' }}>
                                {(this.props.header.information.isSearchable || true) && (<input  value={this.state.text}  onChange={event => this.search(true, event.target.value, true)} placeholder={translate("search ...")} style={{ fontSize: 13, alignSelf: 'stratch', padding: 5, margin: 5, height: 35, backgroundColor: '#f7f7f7', borderRadius: 4, borderWidth: 1, borderStyle: 'solid', borderColor: '#eee', marginTop: 5 }} className={'text-start'} />)}

                                {this.state.options.map((prop, index) => {
                                    let selected = false
                                    for (var i = 0; i < this.state.choosen.length; i++) {

                                        if (prop.value == this.state.choosen[i].value)
                                            selected = true
                                    }
                                    // console.log(prop)

                                    // console.log(selected)
                                    return (
                                        <div key={index} onClick={() => this.changeItem(prop, selected)} style={{ cursor: 'pointer', padding: 5, paddingTop: 10, paddingBottom: 10, borderBottomColor: '#eee', borderBottomStyle: 'solid', borderBottomWidth: 1, backgroundColor: selected ? '#f7f7f7' : '#fff' }}>
                                              <div className="d-flex flex-column justify-content-center">
                                                    <p className="text-bold" style={{ margin: 0, color: '#000', fontSize: 15 }}>{prop.title }</p>
                                                    <p style={{ margin: 0, color: '#789', fontSize: 12, lineHeight: 1.2 }}>{prop.description}</p>

                                                </div>
                                        </div>
                                    )
                                })}

                                {this.state.options.length == 0 && (
                                    <div style={{ cursor: 'pointer', padding: 5, paddingTop: 10, paddingBottom: 10, borderBottomColor: '#eee', borderBottomStyle: 'solid', borderBottomWidth: 1 }}>
                                        <p style={{ textAlign: 'center', margin: 0, color: '#000', opacity: 0.5, fontSize: 13 }}>{translate("useful.foundNothing")}</p>
                                        {this.props.header.information.tag && this.state.title != '' && (<p onClick={() => this.addTag()} style={{ textAlign: 'center', margin: 0, color: '#007aff', fontSize: 13, marginTop: 5, marginBottom: 5, cursor: 'pointer' }}>+ ADD THIS</p>)}

                                    </div>
                                )}
                                {(this.state.isLoadingInside) ? (
                                    <div style={{ position: 'absolute', bottom: 10, left: this.state.openedRect ? this.state.openedRect.width / 2 : 0 }}>
                                        <Loader
                                            type="Oval"
                                            color="rgba(0,122,255,1)"
                                            height="25"
                                            width="25"
                                        />
                                    </div>
                                ) : (

                                    <div ref={this.endOfListRef} style={{ height: '1px', visibility: 'hidden', marginTop: 30 }}></div>
                                )}

                            </div>
                        </div>
                    )}

                </div>



            </div>
        );
    }
}


export default MultiSelectFilterInput;
